import { Capacitor, registerPlugin } from '@capacitor/core';

export const NativeRadio = registerPlugin('RadioPlayer');
export const usesNativeRadio = Capacitor.getPlatform() === 'android';
